import React, { useEffect, useState } from "react";
import he from "he";

interface Props {
    type: string;
    name: string;
    placeholder: string;
    changeDefault?: number;
    defaultValue?: any | undefined;
    readOnly?: boolean;
    updateChange?: (value: any) => void;
    className?: string;
    minValue?: number;
    maxValue?: number;
    validate?: {
        check?: boolean;
        data: { status?: boolean; message?: string };
        className?: string;
    };
    onClick?: () => void;
    focusOut?: (value: any, customId?: any) => void;
    onKeyDown?: (e: any, value: any) => void;
    step?: number;
    counter?: boolean;
    maxCounter?: number;
    container?: boolean;
    hideLabel?: boolean;
    autoFocus?: boolean;
    required?: boolean;
}

const Input: React.FC<Props> = ({
    type,
    name,
    placeholder,
    changeDefault,
    defaultValue,
    readOnly,
    updateChange,
    className,
    validate = {
        check: false,
        data: { status: true, message: "" },
        className: "",
    },
    minValue,
    maxValue,
    onClick,
    focusOut,
    onKeyDown,
    step,
    counter,
    maxCounter = 0,
    container = true,
    hideLabel = true,
    autoFocus = false,
    required = false,
}) => {
    const [value, setValue] = useState("");
    const [defaultCount, setDefaultCount] = useState(0);
    const [focus, setFocus] = useState(false);

    const input_ref = (_: any) => {
        if (!_) return;
        if (autoFocus && value.length === 0) return _.focus();
    };

    useEffect(() => {
        if (changeDefault !== defaultCount && changeDefault) {
            setDefaultCount(changeDefault);
            setValue(defaultValue ? he.decode(defaultValue.toString() || "") : "");
        }
    });

    return (
        <div className={container ? "input-container field " + (className ? className : "") : className}>
            <label className={hideLabel ? "d-none" : "input-label"}>{placeholder}</label>
            <input
                readOnly={readOnly || false}
                type={type}
                name={name}
                value={value}
                placeholder={placeholder}
                step={step ? step : ""}
                min={type === "number" ? minValue : ""}
                max={type === "number" ? maxValue : ""}
                className={`${validate.check ? (validate.data.status ? "" : "error") : ""} ${required && value.length === 0 ? "error" : ""} input-field`}
                onChange={(e) => {
                    setValue(e.target.value);
                    if (updateChange) updateChange(e.target.value);
                }}
                onClick={() => {
                    if (onClick) onClick();
                }}
                onFocus={() => {
                    setFocus(true);
                }}
                onBlur={() => {
                    setFocus(false);
                    if (focusOut) {
                        focusOut(value);
                    }
                }}
                onKeyDown={(e) => {
                    if (onKeyDown) onKeyDown(e, value);
                }}
                ref={input_ref}
            />
            <div className={validate.data.message !== "" ? "small red " + validate.className : "d-none"}>{validate.data.message}</div>
            {counter === true && value.length >= Math.round(maxCounter * 0.8) ? (
                <div className={maxCounter && maxCounter < value.length ? "red d-inline-block" : "d-inline-block"}>
                    <small className={maxCounter && maxCounter < value.length ? "red" : ""}>
                        {value.length}
                        {maxCounter ? `/${maxCounter}` : ""}
                    </small>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};

export default Input;
